/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TemplateTypes_TemplateTypeFragment = { __typename: 'TemplateType', id: string, title: string, description: string, createdAt: any };

export type TemplateTypesQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filter?: Types.InputMaybe<Types.SearchTemplateTypesFilter>;
  sorting?: Types.InputMaybe<Array<Types.SearchTemplateTypesSortingInput>>;
}>;


export type TemplateTypesQuery = { searchTemplateTypes: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'SearchTemplateTypesResultConnection', totalCount: number, edges: Array<{ __typename: 'SearchTemplateTypesResultEdge', node: { __typename: 'TemplateType', id: string, title: string, description: string, createdAt: any } }> } };

export const TemplateTypes_TemplateTypeFragmentDoc = gql`
    fragment TemplateTypes_TemplateType on TemplateType {
  id
  title
  description
  createdAt
}
    `;
export const TemplateTypesDocument = gql`
    query TemplateTypes($offset: Int, $limit: Int!, $searchTerm: String, $filter: SearchTemplateTypesFilter, $sorting: [SearchTemplateTypesSortingInput!]) {
  searchTemplateTypes(
    offset: $offset
    limit: $limit
    searchTerm: $searchTerm
    filter: $filter
    sorting: $sorting
  ) {
    ... on SearchTemplateTypesResultConnection {
      edges {
        node {
          ...TemplateTypes_TemplateType
        }
      }
      totalCount
    }
  }
}
    ${TemplateTypes_TemplateTypeFragmentDoc}`;

/**
 * __useTemplateTypesQuery__
 *
 * To run a query within a React component, call `useTemplateTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateTypesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchTerm: // value for 'searchTerm'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useTemplateTypesQuery(baseOptions: Apollo.QueryHookOptions<TemplateTypesQuery, TemplateTypesQueryVariables> & ({ variables: TemplateTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateTypesQuery, TemplateTypesQueryVariables>(TemplateTypesDocument, options);
      }
export function useTemplateTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateTypesQuery, TemplateTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateTypesQuery, TemplateTypesQueryVariables>(TemplateTypesDocument, options);
        }
export function useTemplateTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateTypesQuery, TemplateTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateTypesQuery, TemplateTypesQueryVariables>(TemplateTypesDocument, options);
        }
export type TemplateTypesQueryHookResult = ReturnType<typeof useTemplateTypesQuery>;
export type TemplateTypesLazyQueryHookResult = ReturnType<typeof useTemplateTypesLazyQuery>;
export type TemplateTypesSuspenseQueryHookResult = ReturnType<typeof useTemplateTypesSuspenseQuery>;
export type TemplateTypesQueryResult = Apollo.QueryResult<TemplateTypesQuery, TemplateTypesQueryVariables>;